<!--
  * 时间：2024/11/8
  * 作者：刘岩
  * 描述：页脚
-->
<template>
  <div class="footer">
    <div class="footer-top">
      <div class="text">
        <span class="h1">产品中心</span>
        <span>智慧博物馆</span>
        <span>智慧导览</span>
        <span>场馆安防</span>
      </div>
      <div class="text">
        <span class="h1">解决方案</span>
        <span>解决方案</span>
      </div>
      <div class="text">
        <span class="h1">关于博筑</span>
        <span>公司简介</span>
      </div>
      <div class="text">
        <span class="h1">业绩展示</span>
        <span>业绩展示</span>
      </div>
      <div class="text">
        <span class="h1">联系我们</span>
        <span>业务咨询：13683267903</span>
        <span>联系地址：天津市西青区张家窝镇香海花园29栋</span>
      </div>
      <div class="qrCode">
        <img class="qrCode" src="@/assets/qrCode.jpg" alt="">
      </div>
    </div>
    <div class="footer-bottom">
      <span>天津博筑智能技术有限公司 津ICP备2025029036号</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "index"
}
</script>

<style scoped lang="less">
.footer {
  width: 100%;
  background: rgba(0, 0, 0, 0.8);
  //padding: 20px 0 0 20px;
  padding: 0 100px;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  .footer-top {
    flex: 1;
    font-size: 16px;
    display: flex;
    justify-content: space-between;
    padding: 50px 0;
    .text {
      display: flex;
      flex-direction: column;
      text-align: left;
      .h1 {
        font-size: 20px;
      }
      & > span {
        margin: 10px 0;
      }
    }
    .qrCode {
      width: 150px;
    }
  }
  .footer-bottom {
    height: 100px;
    line-height: 100px;
    border-top: 1px solid #ffffff;
    font-size: 16px;
  }
}
</style>
